<template>
  <el-table
    :data="tableData"
    style="width: 100%"
    stripe
    max-height="220"
    border
    show-summary
    :sum-text="`共 ${tableData.length} 人`"
  >
    <el-table-column prop="csoMemberName" label="业务员名称"> </el-table-column>
    <el-table-column prop="targetTaskName" label="任务名称"> </el-table-column>
    <el-table-column prop="amount" label="完税凭证金额（元）">
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  name: "GroupTaskTable",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style scoped lang="scss"></style>
